import script from "./lutas.vue?vue&type=script&setup=true&lang=js"
export * from "./lutas.vue?vue&type=script&setup=true&lang=js"

import "./lutas.vue?vue&type=style&index=0&id=ded95d6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ded95d6a"]])

export default __exports__